import { useMemo } from "react";
import useAuth from "./useAuth";

const useFilterOffice = ()=>{
    const {
        officeId,
        isFO,
        officeIdList,
        isOfficeManagementOnly
    } = useAuth();

    const filterOfficeId = useMemo(()=>{
        return isFO
            ? officeIdList.join(',')
            : isOfficeManagementOnly
            ? officeId
            : undefined
    },[isFO, isOfficeManagementOnly, officeId, officeIdList])

    return filterOfficeId
}
export default useFilterOffice;